<div *ngIf="isDebugging" style="position: fixed; top: 0; left: 100px; background-color: white; border: 1px solid black; z-index: 99999;">
  <input type="checkbox" [(ngModel)]="isPropak" (change)="onSettingsChange()"> Propak
  <input type="checkbox" [(ngModel)]="isTestEnvironment" (change)="onSettingsChange()"> Test
</div>
<div class="layout-wrapper layout-menu-static layout-menu-light"
  [ngClass]="{
    'theme-propak': isPropak,
    'layout-menu-overlay-active': overlayMenuActive,
    'layout-menu-mobile-active': staticMenuMobileActive,
    'layout-menu-static-inactive': staticMenuDesktopInactive
  }"
  (click)="onLayoutClick()">

  <theme-topbar [isPropak]="isPropak" [isTestEnvironment]="isTestEnvironment"></theme-topbar>

  <theme-menu [reset]="resetMenu"></theme-menu>

  <div class="layout-main">
      <div class="loading-overlay" [class.shown]="showLoadingOverlay">
        <i class="pi pi-spin pi-spinner" *ngIf="!authMessage"></i>
      </div>
      <theme-breadcrumb></theme-breadcrumb>

      <ng-content></ng-content>

      <div class="layout-content">
          <router-outlet></router-outlet>
      </div>

      <theme-footer [buildNumber]="buildNumber"></theme-footer>
  </div>

  <app-toast position="top-right"></app-toast>
</div>
